import { Form } from "antd";
import { Autocomplete } from "components/UI";
import useSuggestion from "hooks/useSuggestion";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { cleanBlankValue } from "utils/helper";
import { useInfiniteCountrySuggestion } from "queries/location";

const CountrySelector = ({
  autocompleteProps,
  name = "country_id",
  defaultValue = {
    id: 1,
    name: "Indonesia",
    currency_code: "IDR",
    country_code_alpha3: "IDN",
    country_code_alpha2: "ID",
  },
  ...props
}) => {
  const {
    debouncedSearch,
    onDropdownVisible,
    getPopupContainer,
    onPopUpScroll,
    containerId,
    onSearch,
    popUpClassName,
    open,
  } = useSuggestion({
    name,
    module: "country",
  });
  const { t } = useTranslation();

  const params = useMemo(() => {
    const newParams = { search: debouncedSearch };

    return cleanBlankValue(newParams);
  }, [debouncedSearch]);

  const { data, isLoading, isFetchingNextPage, fetchNextPage, hasNextPage } =
    useInfiniteCountrySuggestion(params, {
      refetchOnMount: false, // karena datanya tidak pernah berubah, jadi ketika remount tidak perlu refetch
    });

  const formattedData = useMemo(() => {
    let newData = data?.pages.flatMap((page) => page.data) || [];
    if (!newData.some((data) => data.id === defaultValue?.id)) {
      newData.unshift(defaultValue);
    }
    return newData.map((row) => {
      return {
        ...row,
        value: row?.id,
        label: row?.name,
      };
    });
  }, [data?.pages, defaultValue]);

  const popUpScrollHandler = useCallback(
    (e) => {
      onPopUpScroll(e, { hasNextPage, isFetchingNextPage, fetchNextPage });
    },
    [fetchNextPage, hasNextPage, isFetchingNextPage, onPopUpScroll]
  );

  return (
    <Form.Item id={containerId} name={name} {...props}>
      <Autocomplete
        placeholder={t("country")}
        options={formattedData}
        allowClear
        onSearch={onSearch}
        infiniteScroll
        onPopupScroll={popUpScrollHandler}
        onDropdownVisibleChange={onDropdownVisible}
        loading={isLoading}
        loadingNextPage={isLoading || isFetchingNextPage}
        getPopupContainer={getPopupContainer}
        popupClassName={popUpClassName}
        open={open}
        optionLabelProp="label"
        {...autocompleteProps}
      />
    </Form.Item>
  );
};

export default CountrySelector;
